














































































































































































































































































































































































import {opportunityFormMixin} from '@/shared';
import {Actions} from '@/store';
import {ToastsService} from '@/utils';
import mixins from 'vue-typed-mixins';

export default mixins(opportunityFormMixin).extend({
  name: 'OpportunityNewView',
  data() {
    return {
      approversLimit: 2,
      required: false,
    };
  },
  computed: {
    isRequired(): boolean {
      return this.required;
    },
  },
  methods: {
    async addOpportunity() {
      this.required = true;
      await this.$nextTick();
      const isFormValid = await this.$validator.validate();

      if (!isFormValid) {
        return;
      }

      const outputTags = this.form.tags.map(t => t.id ? {id: t.id} : {value: t.value});
      const outputApprovers = this.form.approvers.map(a => a.id);
      const newOpportunity = {...this.form, tags: outputTags, approvers: outputApprovers};

      this.loader.isOpportunityCreateRequestSending = true;
      try {
        const response = await this.$store.dispatch(Actions.opportunities.create, newOpportunity);
        ToastsService.success(this.$t('opportunities.new.form.notifications.create-success') as string);
        this.$router.push({
          name: 'opportunity-details',
          params: {
            id: response.id,
            showAfterCreatingOpportunityModal: 'true',
          },
        });
      } finally {
        this.loader.isOpportunityCreateRequestSending = false;
      }
    },
    async saveDraft() {
      this.required = false;
      await this.$nextTick();

      const isFormValid = await this.$validator.validate();
      if (!isFormValid) {
        return;
      }

      const outputTags = this.form.tags.map(t => t.id ? {id: t.id} : {value: t.value});
      const outputApprovers = this.form.approvers.map(a => a.id);
      const opportunityDraft = {...this.form, tags: outputTags, approvers: outputApprovers};

      this.loader.isOpportunityCreateRequestSending = true;
      try {
        const response = await this.$store.dispatch(Actions.opportunities.drafts.create, opportunityDraft);
        ToastsService.success(this.$t('opportunities.new.form.notifications.create-draft-success') as string);
        this.$router.push({
          name: 'opportunity-draft-details',
          params: {
            id: response.id,
          },
        });
      } finally {
        this.loader.isOpportunityCreateRequestSending = false;
      }
    },
  },
});
